import { flattenTree } from '../flattenTree';
import { TYPES } from '../flattenTree/utils/consts';
import { toUrlFormat } from '../treeVisitors';
import { getName } from '../treeVisitors/helpers';
import { getSortOrder } from '../applyMenuConfigChanges/addSortOrderProperty/sortBySortOrder';
import { flattenSubMembers } from '../flattenTree/utils';

const removeSlashes = (text) => text.replace(/\//g, '');

export const toMemberFormat = (base) => ({ name, id, type, sortOrder }) => {
  return {
    name,
    path: removeSlashes(base ? `${base}.${id}` : id),
    type,
    sortOrder: getSortOrder({ sortOrder }),
    visible: true,
  };
};

export const createDefaultCategory = (name) => ({
  sortOrder: null,
  visible: true,
  type: TYPES.CATEGORY,
  path: toUrlFormat(name),
  name,
  members: [],
});

const buildConfigCategoryMembers = (categoryKey, data) => {
  const categoryMembers = Object.values(
    flattenSubMembers(categoryKey, data),
  ).map(toMemberFormat());

  const subCategoryMembers = Object.values(flattenTree(data)).map(
    toMemberFormat(categoryKey),
  );
  return [...categoryMembers, ...subCategoryMembers];
};

export const hasSortOrder = (member) => typeof member.sortOrder === 'number';

export const deleteEmptySortOrder = (member) => {
  if (!hasSortOrder(member)) {
    delete member.sortOrder;
  }
};

export const deleteEmptySortdOrders = (config) => {
  config.categories.forEach((category) => {
    deleteEmptySortOrder(category);
    category.members.forEach((member) => {
      deleteEmptySortOrder(member);
    });
  });
};

export const generateDefaultMenuConfig = (docsTree) => {
  const config = {
    categories: [],
  };
  Object.entries(docsTree).forEach(([key, value]) => {
    const category = {
      sortOrder: getSortOrder(value.data),
      visible: true,
      type: TYPES.CATEGORY,
      path: removeSlashes(key),
      name: getName(value.data),
      members: buildConfigCategoryMembers(key, value),
    };
    config.categories.push(category);
  });
  deleteEmptySortdOrders(config);
  return config;
};
